import jwtDecode from 'jwt-decode';

export default {
  signIn({ commit }, { authToken }) {
    if (!authToken) {
      throw new Error('authToken is required!');
    }

    commit('UPDATE_CURRENT_USER', jwtDecode(authToken));
  },

  signOut({ commit }) {
    commit('UPDATE_CURRENT_USER', null);
  },
};
